import styled from "@emotion/styled";
import {
  Button,
  CircularProgress,
  IconButton,
  Skeleton,
  Stack,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useModal } from "mui-modal-provider";
import { useCallback, useMemo, useState } from "react";
import usePayment from "../../../../hooks/usePayment";
import useSite from "../../../../hooks/useSite";
import { capitalizeFirstLetter } from "../../../../utils/capitalizeFirstLetter";
import SubCard from "../../../components/cards/SubCard";
import NoResultFound from "../../../components/NoResultFound";
import AddPaymentsModal from "../AddPaymentsModal";
import AddScheduledPaymentsModal from "./AddScheduledPaymentModal";
// import MarkPaymentDoneModal from "./MarkPaymentDoneModal";
// import { useNavigate } from "react-router";
import { IconPlus } from "@tabler/icons-react";
import SendIcon from "@mui/icons-material/Send";
import useResendMail from "../../../../hooks/useResendMail";
import { useSnackbarHelper } from "../../../components/Snackbar";
import ResendMailConfirmation from "../../../components/ResendMailConfirmation";
// import useAuth from "../../../../hooks/useAuth";
// import useUser from "../../../../hooks/useUser";

const CustomTableRow = styled(TableRow)(() => ({
  height: "50px",
}));
const CustomTableCell = styled(TableCell)(() => ({
  paddingTop: 0,
  paddingBottom: 0,
  gap: 5,
  // fontSize: "15px",
}));

const PaymentScheduling = ({
  caseData,
  caseId,
  isCaseClosed,
  isAgreementNotSigned,
  isExistingClient,
}: any) => {
  const { showModal } = useModal();
  const showSnackbar = useSnackbarHelper();
  const { paymentScheduling, refetchPayment } = usePayment(caseId?.id);
  const { isSiteLoading } = useSite();
  const {
    resendPaymentSchedule,
    resendPaymentReminder,
    isLoading,
    isResendPaymentSchedule,
  } = useResendMail();
  const [resendMailSpreadId, setResendMailSpreadId] = useState(null);
  const [resendMailReminderId, setResendMailReminderId] = useState(null);

  // const { userId } = useAuth();
  // const { isStaff } = useUser(userId);

  const isClientHiredAnotherAttorney = useMemo(
    () => caseData?.isClientHiredAnotherAttorney,
    [caseData]
  );

  // const checkQuickBooksIntegrated = useCallback(() => {
  //   const accessToken = site?.quickBooks?.accessToken;
  //   return !!accessToken;
  // }, [site]);

  const isUnRetained = useMemo(
    () => caseData?.caseStatus === "unretained",
    [caseData]
  );

  const isPaymentCompleted = useMemo(() => {
    return paymentScheduling?.payment?.every(
      (payment: any) => payment.isPaymentCompleted === true
    );
  }, [paymentScheduling]);

  const handleAddScheduledPayment = useCallback(() => {
    const modal: any = showModal(AddScheduledPaymentsModal, {
      onClose: () => modal.hide(),
      caseData,
      caseId,
    });
  }, [showModal, caseId, caseData]);

  // const handleAdd = useCallback(() => {
  //   const modal: any = showModal(AddPaymentsModal, {
  //     onClose: () => modal.hide(),
  //   });
  // }, [showModal]);

  const handlePay = useCallback(
    (paymentScheduling: any, payment_spread: any) => {
      const modal: any = showModal(AddPaymentsModal, {
        onClose: () => modal.hide(),
        data: paymentScheduling,
        contactName:
          caseData?.contactId?.firstName + " " + caseData?.contactId?.lastName,
        clientEmail: caseData?.contactId?.email[0].email,
        clientZip: caseData?.contactId?.zip,
        caseId,
        payment_spread,
        refetchPayment,
      });
    },
    [showModal, caseId, caseData, refetchPayment]
  );

  const handleResendPaymentSchedule = useCallback(() => {
    const client = caseData?.contactId;
    const lastPayment = paymentScheduling?.payment?.at(-1); //get last schedlued payment
    const case_Id = caseId?.id;
    const payload = { client, payment: lastPayment, case_Id };

    const modal: any = showModal(ResendMailConfirmation, {
      onClose: () => modal.hide(),
      onSubmit: async () => {
        try {
          const result = await resendPaymentSchedule(payload);
          const message = result?.message || "Success";
          showSnackbar(message, "success");
        } catch (error: any) {
          const message =
            error?.response?.result?.message || "An error occurred";
          showSnackbar(message, "error");
        }
      },
      title: "Resend Mail",
      content: "Do you really want to resend this email?",
    });
  }, [showModal, resendPaymentSchedule, paymentScheduling]);

  // const handleResendPaymentSchedule = useCallback(async () => {
  //   try {
  //     const client = caseData?.contactId;
  //     const lastPayment = paymentScheduling?.payment?.at(-1); //get last schedlued payment
  //     const case_Id = caseId?.id;
  //     const payload = { client, payment: lastPayment, case_Id };

  //     const response = await resendPaymentSchedule(payload);
  //     const message = response?.message;
  //     showSnackbar(message, "success");
  //   } catch (err: any) {
  //     console.log(err?.response?.message);
  //   }

  //   //eslint-disable-next-line
  // }, [caseData, paymentScheduling]);

  const handleResendPaymentReminder = useCallback(
    (paymentId: any, spreadIndex: any, reminderIndex: any) => {
      const payload = {
        paymentId: paymentId,
        spreadIndex: spreadIndex,
        reminderIndex: reminderIndex,
      };

      const modal: any = showModal(ResendMailConfirmation, {
        onClose: () => modal.hide(),
        onSubmit: async () => {
          try {
            const result = await resendPaymentReminder(payload);
            const message = result?.message || "Success";
            showSnackbar(message, "success");
          } catch (error: any) {
            const message =
              error?.response?.result?.message || "An error occurred";
            showSnackbar(message, "error");
          }
        },
        title: "Resend Mail",
        content: "Do you really want to resend this email?",
      });
    },
    [showModal, resendPaymentSchedule, paymentScheduling]
  );

  // const handleResendPaymentReminder = useCallback(
  //   async (paymentId: any, spreadIndex: any, reminderIndex: any) => {
  //     try {
  //       setResendMailSpreadId(spreadIndex);
  //       setResendMailReminderId(reminderIndex);
  //       const payload = {
  //         paymentId: paymentId,
  //         spreadIndex: spreadIndex,
  //         reminderIndex: reminderIndex,
  //       };
  //       const response = await resendPaymentReminder(payload);
  //       const message = response?.message;
  //       showSnackbar(message, "success");
  //       if (response) {
  //         setResendMailSpreadId(null);
  //         setResendMailReminderId(null);
  //       }
  //     } catch (err: any) {
  //       setResendMailSpreadId(null);
  //       setResendMailReminderId(null);
  //       console.log(err?.response?.message);
  //     }
  //   },
  //   //eslint-disable-next-line
  //   [caseData]
  // );

  const isFirstPaymentPaid = useCallback((payment: any, index: any) => {
    if (index === 0) {
      return false;
    }

    return !payment?.payment_spreads?.[index - 1]?.isPaid || false;
  }, []);

  if (isSiteLoading) {
    return <Skeleton />;
  }

  const hasUnpaidPayments = paymentScheduling?.payment?.some(
    (paymentItem: any) =>
      paymentItem?.payment_spreads?.some((payment: any) => !payment?.isPaid)
  );

  return (
    <SubCard
      title={"Payments Scheduled"}
      secondary={
        <>
          {isPaymentCompleted ? (
            <Button
              sx={{
                color: "green",
                cursor: "pointer",
              }}
              onClick={handleAddScheduledPayment}
              // disabled={isUnRetained || isCaseClosed}
              disabled={
                isUnRetained ||
                isCaseClosed ||
                isClientHiredAnotherAttorney ||
                isAgreementNotSigned
                // (isAgreementNotSigned && !isExistingClient)
              }
            >
              {/* <IconPlus /> */}
              {/* {isAgreementNotSigned && !isExistingClient ? (
                "Rep Agreement Not Signed"
              ) : (
                <IconPlus />
              )} */}
              {isAgreementNotSigned ? "Rep Agreement Not Signed" : <IconPlus />}
            </Button>
          ) : (
            ""
          )}
          {paymentScheduling?.payment?.length > 0 &&
            hasUnpaidPayments &&
            (isResendPaymentSchedule ? (
              <IconButton sx={{ cursor: "default" }} disableRipple>
                <CircularProgress
                  size={24}
                  // sx={{ mt: 1, mr: 2 }}
                />
              </IconButton>
            ) : (
              <Tooltip title={"Resend Payment Schedule Email"}>
                <IconButton
                  onClick={() => handleResendPaymentSchedule()}
                  // disabled={isLoadingDocuSignMail}
                >
                  <SendIcon fontSize="medium" style={{ color: "#1976d2" }} />
                </IconButton>
              </Tooltip>
            ))}
        </>
      }
    >
      {/* {!!paymentScheduling?.payment?.length ? ( */}
      {!!paymentScheduling?.payment?.length && hasUnpaidPayments ? (
        <TableContainer sx={{ maxHeight: 400, overflow: "auto" }}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <CustomTableRow
              sx={{ position: "sticky", top: 0, bgcolor: "white", zIndex: 1 }}
            >
              <CustomTableCell>
                {" "}
                <Typography variant="h5">Date</Typography>
              </CustomTableCell>
              <CustomTableCell>
                {" "}
                <Typography variant="h5">Amount(USD)</Typography>
              </CustomTableCell>
              {/* <CustomTableCell>Payment Interval</CustomTableCell> */}
              <CustomTableCell>
                {" "}
                <Typography variant="h5">Type</Typography>
              </CustomTableCell>
              <CustomTableCell>
                {" "}
                <Typography variant="h5">
                  Reminder Type / Email Status
                </Typography>
              </CustomTableCell>
              {/* <CustomTableCell>UnPaid</CustomTableCell> */}
              {/* <CustomTableCell>Paid</CustomTableCell> */}
              <CustomTableCell width={50} align="center">
                <Typography variant="h5">Actions</Typography>
              </CustomTableCell>
            </CustomTableRow>
            {paymentScheduling?.payment?.map((paymentItem: any) =>
              paymentItem?.payment_spreads?.map(
                (payment: any, spreadIndex: any) =>
                  !payment?.isPaid ? (
                    <CustomTableRow key={payment?._id}>
                      <CustomTableCell>
                        {moment(payment?.dueDate).format("MM/DD/YYYY")}
                      </CustomTableCell>
                      <CustomTableCell>
                        $ {Number(payment?.payment)?.toFixed(2)}
                      </CustomTableCell>
                      {/* <CustomTableCell>{payment.paymentInterval}</CustomTableCell> */}
                      <CustomTableCell>
                        {capitalizeFirstLetter(paymentItem?.type)}
                      </CustomTableCell>
                      <CustomTableCell width={250}>
                        {" "}
                        <Typography>
                          {payment?.reminder?.map((val: any, index: any) => (
                            <Stack direction={"row"} justifyContent={"center"}>
                              <Typography variant="h5" key={index}>
                                {capitalizeFirstLetter(val?.reminderType)} /{" "}
                                {val?.isReminderSent ? "Sent" : "Not Sent"}
                              </Typography>
                              {isLoading &&
                              resendMailSpreadId === spreadIndex &&
                              resendMailReminderId === index ? (
                                <CircularProgress size={25} sx={{ ml: 1 }} />
                              ) : (
                                val?.isReminderSent && (
                                  <Tooltip title={"Resend Reminder Email"}>
                                    <IconButton
                                      onClick={() =>
                                        handleResendPaymentReminder(
                                          paymentItem?._id,
                                          spreadIndex,
                                          index
                                        )
                                      }
                                      sx={{ mt: -1 }}
                                    >
                                      <SendIcon
                                        fontSize="small"
                                        style={{
                                          color: "#1976d2",
                                        }}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                )
                              )}
                            </Stack>
                          ))}
                        </Typography>
                      </CustomTableCell>
                      {/* <CustomTableCell>{payment.noOfPayments}</CustomTableCell> */}
                      {/* <CustomTableCell>0</CustomTableCell> */}
                      <CustomTableCell>
                        <Stack direction={"row"} spacing={2}>
                          {/* <Button
                        variant="outlined"
                        size="small"
                        color="success"
                        onClick={() => handleEditScheduling(payment)}
                      >
                        View
                      </Button> */}
                          {/* <IconEdit
                        stroke={2}
                        style={{ cursor: "pointer", color: "gray" }}
                        onClick={() => handleEditScheduling(payment)}
                      /> */}
                          {/* <IconEye
                      stroke={2}
                      style={{ cursor: "pointer", color: "gray" }}
                      onClick={() => handleEditScheduling(payment)}
                        /> */}
                          <Button
                            variant="contained"
                            size="small"
                            // disabled={paymentItem?.type === "lawpay" || isStaff}
                            disabled={isFirstPaymentPaid(
                              paymentItem,
                              spreadIndex
                            )}
                            color="success"
                            onClick={() => handlePay(paymentItem, payment)}
                          >
                            Pay
                          </Button>
                          {/* <IconTrash
                        stroke={2}
                        style={{ cursor: "pointer", color: "red" }}
                        onClick={() => handleDelete(payment)}
                      /> */}
                        </Stack>
                      </CustomTableCell>
                    </CustomTableRow>
                  ) : null
              )
            )}
          </Table>
        </TableContainer>
      ) : (
        <NoResultFound>No Payment Schedule</NoResultFound>
      )}
    </SubCard>
  );
};

export default PaymentScheduling;
